import React from "react";
import { ChevronDown, Globe, UserCheck, Calendar, Newspaper } from "lucide-react";
import "./TopNav.css";

function TopNav() {
  const [langOpen, setLangOpen] = React.useState(false);
  const [sessionOpen, setSessionOpen] = React.useState(false);

  // Fecha dropdowns ao clicar fora
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".topnav__dropdown")) {
        setLangOpen(false);
        setSessionOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="topnav" role="navigation" aria-label="Barra superior">
      <div className="topnav__container">
        <div className="topnav__left">
         {/* Idioma Dropdown (oculto no mobile) */}
          <div className={`topnav__dropdown topnav__mobile-hidden ${langOpen ? "open" : ""}`}>
            <button
              className="topnav__link"
              onClick={() => {
                setLangOpen(!langOpen);
                setSessionOpen(false);
              }}
              aria-haspopup="true"
              aria-expanded={langOpen}
            >
              <Globe size={16} />
              <span>Português</span>
              <ChevronDown size={14} className="topnav__chevron" />
            </button>
            <ul className="topnav__dropdown-menu" role="menu">
              <li><a href="#pt" onClick={() => setLangOpen(false)}>Português</a></li>
              <li><a href="#en" onClick={() => setLangOpen(false)}>Inglês</a></li>
              <li><a href="#fr" onClick={() => setLangOpen(false)}>Francês</a></li>
              <li><a href="#es" onClick={() => setLangOpen(false)}>Espanhol</a></li>
            </ul>
          </div>

          {/* Links Desktop */}
          <a href="/comunicacao/eventos" className="topnav__link topnav__desktop-only">
            <Calendar size={16} /> Eventos
          </a>
          <a href="/comunicacao/noticias" className="topnav__link topnav__desktop-only">
            <Newspaper size={16} /> Notícias
          </a>
          <a href="/portal-do-estudante/preparatorio-online" className="topnav__link topnav__desktop-only">
            <UserCheck size={16} /> Preparatório Online
          </a>
        </div>

        <div className="topnav__right">
          <div className={`topnav__dropdown ${sessionOpen ? "open" : ""}`}>
            <button
              className="topnav__link topnav__login"
              onClick={() => {
                setSessionOpen(!sessionOpen);
                setLangOpen(false);
              }}
              aria-haspopup="true"
              aria-expanded={sessionOpen}
            >
              <UserCheck size={16} />
              <span>Portal do Estudante</span>
              <ChevronDown size={14} className="topnav__chevron" />
            </button>
            <ul className="topnav__dropdown-menu" role="menu">
              <li>
                <a href="https://portalonline.icsgisabelinha.com/" onClick={() => setSessionOpen(false)}>
                 Portal do Estudante
                </a>
              </li>
              <li>
                <a href="/portal-do-estudante/preparatorio-online" rel="noopener noreferrer" onClick={() => setSessionOpen(false)}>
                  Preparatório Online 
                </a>
              </li>
              <li>
                <a href="https://portalonline.icsgisabelinha.com/Publico/Candidaturas/Candidatura" onClick={() => setSessionOpen(false)}>
                  Inscrições Online
                </a>
              </li>
                <li>
                <a href="/portal-do-estudante/admin-Candidatura" onClick={() => setSessionOpen(false)}>
                  Portal Candidaturas
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopNav;
